// in src/NotFound.js
import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

const Error404 = () => (
    <Card>
        <CardContent>
            <h1>404: Not found</h1>
        </CardContent>
    </Card>
);

export default Error404;